import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=1d52b198&scoped=true&lang=pug&"
import script from "./Language.vue?vue&type=script&lang=ts&"
export * from "./Language.vue?vue&type=script&lang=ts&"
import style0 from "./Language.vue?vue&type=style&index=0&id=1d52b198&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52b198",
  null
  
)

export default component.exports